module.exports = __webpack_public_path__ + "img/icon-up.b22c407d.svg";